export const getFormikChangedProperties = (
  obj: { [key: string]: unknown },
  initialObj: { [key: string]: unknown }
) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([field, value]) => {
      return initialObj[field] !== value;
    })
  );
};
